import TeslaRoute from './tesla-router';
import BirthdayRoute from './birthday-router';

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../pages/index'),
  },
  {
    path: '/notfoundInDD',
    name: 'notfoundInDD',
    component: () => import('../pages/notInDD'),
  },
  {
    path: '/pages/interviewArrangement',
    name: 'interviewArrangement',
    meta: {
      title: '招聘管理',
    },
    component: () => import('../pages/interviewnew/arrange'),
  },
  {
    path: '/books/list',
    name: 'booksList',
    meta: {
      title: '掌经阁',
    },
    component: () => import('../pages/books/list.vue'),
    // component: () => import('../pages/stationOnline/index.vue'),
  },
  {
    path: '/pact/detail',
    name: 'pactDerail',
    meta: {
      title: '电子合同',
    },
    component: () => import('../pages/pact/pact.vue'),
  },
  {
    path: '/pact/mail',
    name: 'pactMail',
    meta: {
      title: '电子合同',
    },
    component: () => import('../pages/pact/mail.vue'),
  },
  {
    path: '/pact/pdf',
    name: 'pactPdf',
    meta: {
      title: '电子合同',
    },
    component: () => import('../pages/pact/pdfh5.vue'),
  },
  {
    path: '/finance/manage',
    name: 'financeManage',
    meta: {
      title: '财务配置管理',
    },
    component: () => import('../pages/finance/manage.vue'),
  },
  {
    path: '/stationOnline',
    name: 'stationOnline',
    meta: {
      title: '工位线上化',
    },
    component: () => import('../pages/stationOnline/index.vue'),
  },
  {
    path: '/pay/login',
    name: '/payLogin',
    meta: {
      title: '薪资查询',
    },
    component: () => import('../pages/pay/login.vue'),
  },
  {
    path: '/pay/search',
    name: '/paySearch',
    meta: {
      title: '薪资查询',
    },
    component: () => import('../pages/pay/index.vue'),
  },
  {
    path: '/pay/rules',
    name: '/payRules',
    meta: {
      title: '薪资注意事项说明',
    },
    component: () => import('../pages/pay/rules.vue'),
  },
  {
    path: '/common/iframe',
    name: 'commonIframe',
    meta: {
      title: '资产管理',
    },
    component: () => import('../pages/iframe.vue'),
  },
  {
    path: '/meal/manage',
    name: 'mealManage',
    meta: {
      title: '点餐',
    },
    component: () => import('../pages/meal/manage.vue'),
    redirect: '/meal/menu',
    children: [
      {
        path: '/meal/menu',
        name: 'mealMenu',
        component: () => import('../pages/meal/menu.vue'),
      },
      {
        path: '/meal/order',
        name: 'mealOrder',
        component: () => import('../pages/meal/order.vue'),
      },
      {
        path: '/meal/comment',
        name: 'mealComment',
        component: () => import('../pages/meal/comment.vue'),
      },
    ],
  },
  {
    path:'/warning/reminder',
    name:'warningReminder',
    meta:{
      title:'未打卡预警提醒'
    },
    component:()=>import('../pages/reminder.vue')
  },

  // 特斯拉公众号相关路由
  ...TeslaRoute,
  // 员工福利 订蛋糕相关路由
  ...BirthdayRoute,
];

export default routes;
